// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__2TM1N","tbg":"Form_tbg__1TbVm","form_container":"Form_form_container__1ufQi","form_style":"Form_form_style__2Plqg"};